// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1601":"977acc26","4386":"e7e03147","8158":"f288aad5","9169":"92c83be8","9208":"f77e8b9d"}[chunkId] + ".chunk.css";
};